import { cn } from '@ahm/common-helpers';

type ItemFrameProps = {
  /** `frame_image_url` của món — key vắng hẳn khi món không thuộc chiến dịch. */
  src?: string;
  className?: string;
};

/**
 * Khung chiến dịch (AF-063) vẽ đè lên ảnh món.
 *
 * BE gắn khung lên chính món, mọi API trả món (menu, tìm kiếm, trang quán) đều
 * mang sẵn `frame_image_url` — có thì vẽ, không có thì thôi. Khung là PNG nền
 * trong vuông 1080² → chỉ đặt trong khung ảnh VUÔNG, container phải `relative`.
 *
 * Đặt ngay sau ảnh và TRƯỚC nút/badge của card: phần lớn chúng là z-auto/z-0
 * nên vẽ theo thứ tự DOM, đặt sau là khung đè lên nút thêm món.
 *
 * Đừng coi "món có khung" là "chiến dịch đang chạy" — BE gỡ khung không tức thì.
 */
export function ItemFrame({ src, className }: ItemFrameProps) {
  if (!src?.trim()) return null;
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      aria-hidden
      loading="lazy"
      draggable={false}
      className={cn(
        'pointer-events-none absolute inset-0 size-full select-none',
        className
      )}
    />
  );
}
